import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from './components/form-field-error/form-field-error.component';

@NgModule({
    declarations: [
        FormFieldErrorComponent
    ],
    exports: [
        FormFieldErrorComponent,
        ReactiveFormsModule
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class FormModule {}

